import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env } from '@noor/config';
import { citiesSearchSchema, cityQueries } from '@/entities/city';
import { CitiesPage } from '@/pages/settings';

/** Cities + dispatch grid — the selected city lives in `?city=`. */
export const Route = createFileRoute('/settings/cities')({
  staticData: { permission: 'cities.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: citiesSearchSchema,
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(cityQueries.list()).catch(() => undefined);
  },
  component: RouteCitiesPage,
});

function RouteCitiesPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <CitiesPage
      params={search}
      onParamsChange={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
